import React from 'react';

interface ContainerProps {
  children: React.ReactNode;
}

/**
 * Wraps body in the standardized viewport
 *
 * @param param0
 * @returns
 */
const ContainerComponent: React.FC<ContainerProps> = ({ children }) => {
  return <div className="mx-auto container">{children}</div>;
};

export default ContainerComponent;
